import useSourceFlowCollection from "../hooks/useSourceFlowCollection";
import data from "../.sourceflow/jobs.json";

export const useJobs = ({
  limit = 10,
  regionFilters = null,
  sectorFilters = null,
  jobTypesFilters = null,
} = {}) => {
  let collection = useSourceFlowCollection(data.jobs);

  // Apply Region filters
  if (regionFilters && regionFilters.length > 0) {
    collection = collection.filter(function (job) {
      return job.categories.find((cat) =>
        cat.id === "b4b8be3c-ba95-4912-aa85-2cbc1264449d" &&
        cat.values.some((x) => regionFilters.includes(x.id))
      );
    });
  }

  // Apply Sector filters
  if (sectorFilters && sectorFilters.length > 0) {
    collection = collection.filter((job) =>
      job?.categories.some(
        (cat) =>
          (cat.id === "6201aa1d-bc28-452d-8f5c-9146fa604872" ||
            cat.id === "e937d6f2-07a3-4ac7-bf04-0324eda2eee8") &&
          cat.values?.some((filter) => sectorFilters.includes(filter.id))
      )
    );
  }
  
  // Apply Job Type filters
  if (jobTypesFilters && jobTypesFilters.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === "87757283-767f-4224-85d3-986ac52dc4c5")?.values.some((filter) => jobTypesFilters?.includes(filter.id)));
  }

  // Apply limit
  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
